import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IEndOfProductCollectionWeb_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IEndOfProductCollectionWeb_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  B2BGetUserId: any[];
  B2BGetUserId_dummy: any[];
  B2BEndOfProductFirstPage: any[];
  B2BEndOfProductFirstPage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp202683Visible: "visible" | "hidden";
}

export class EndOfProductCollectionWeb_ScreenBase extends React.PureComponent<
  IEndOfProductCollectionWeb_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  endofproductcollectionweb_135334_value_kuikaGalleryViewRef: React.RefObject<any>;
  endofproductcollectionweb_545877_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 926833,
          PropertyName: "value",
          Value: "Seri Sonu",
          TagName: "Label4_value",
        },
        {
          Id: 978989,
          PropertyName: "placeholder",
          Value: "Koleksiyon Ara",
          TagName: "TextInput3_placeholder",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 926833,
          PropertyName: "value",
          Value: "End of Series",
          TagName: "Label4_value",
        },
        {
          Id: 978989,
          PropertyName: "placeholder",
          Value: "Search Collection",
          TagName: "TextInput3_placeholder",
        },
      ],
    },
    {
      Id: "54c5f9b7-62c5-4e43-8019-703342a959f9",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 926833, PropertyName: "value", Value: "Seri Sonu" },
        { Id: 978989, PropertyName: "placeholder", Value: "Koleksiyon Ara" },
        {
          Id: 135334,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 202683,
          PropertyName: "value",
          Value: "[datafield:productattribute02description]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.endofproductcollectionweb_978989_value_kuikaTextInputRef =
      React.createRef();
    this.endofproductcollectionweb_135334_value_kuikaGalleryViewRef =
      React.createRef();
    this.endofproductcollectionweb_545877_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      B2BGetRolesById: [],
      B2BGetUserId: [],
      B2BEndOfProductFirstPage: [],
      SetValueOf: "",
      NAVIGATE: "",
      isComp202683Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "endofproductcollectionweb",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.EndOfProductCollectionWebPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.EndOfProductCollectionWebPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "endofproductcollectionweb",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "endofproductcollectionweb",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.EndOfProductCollectionWebPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.EndOfProductCollectionWebPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  EndOfProductCollectionWebPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      KUserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      PageNumber_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "endofproductcollectionweb_545877_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      filtre_2: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageSize_2: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfProductCollectionWeb/EndOfProductCollectionWebPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    stateVars.B2BGetUserId = result?.data.b2BGetUserId;
    stateVars.B2BEndOfProductFirstPage = result?.data.b2BEndOfProductFirstPage;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EndOfProductCollectionWebPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfProductCollectionWebPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_135334 =
      stateVars.B2BEndOfProductFirstPage ?? this.state.B2BEndOfProductFirstPage;
    formVars.endofproductcollectionweb_545877_total =
      ReactSystemFunctions.value(
        this,
        stateVars.B2BEndOfProductFirstPage !== undefined
          ? stateVars.B2BEndOfProductFirstPage?.length > 0
            ? stateVars.B2BEndOfProductFirstPage[0].totalRowCount
            : null
          : this.state.B2BEndOfProductFirstPage?.length > 0
          ? this.state.B2BEndOfProductFirstPage[0].totalRowCount
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  EndOfProductCollectionWebComponent_959463_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "endofproductcollectionweb_978989_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfProductCollectionWeb/EndOfProductCollectionWebComponent_959463_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BEndOfProductFirstPage = result?.data.b2BEndOfProductFirstPage;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfProductCollectionWebComponent_959463_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfProductCollectionWebComponent_959463_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "endofproductcollectionweb_545877_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_135334 =
      stateVars.B2BEndOfProductFirstPage ?? this.state.B2BEndOfProductFirstPage;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfProductCollectionWebComponent_197912_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/endofproductdesignweb") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "EndOfProductDesignWeb",
      "ProductAttribute02",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofproductcollectionweb_135334_value",
          "productAttribute02"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EndOfProductCollectionWeb",
      "EndOfProductDesignWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfProductCollectionWebComponent_545877_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "endofproductcollectionweb_545877_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "endofproductcollectionweb_978989_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfProductCollectionWeb/EndOfProductCollectionWebComponent_545877_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BEndOfProductFirstPage = result?.data.b2BEndOfProductFirstPage;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfProductCollectionWebComponent_545877_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfProductCollectionWebComponent_545877_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_135334 =
      stateVars.B2BEndOfProductFirstPage ?? this.state.B2BEndOfProductFirstPage;
    formVars.endofproductcollectionweb_545877_total =
      ReactSystemFunctions.value(
        this,
        stateVars.B2BEndOfProductFirstPage !== undefined
          ? stateVars.B2BEndOfProductFirstPage?.length > 0
            ? stateVars.B2BEndOfProductFirstPage[0].totalRowCount
            : null
          : this.state.B2BEndOfProductFirstPage?.length > 0
          ? this.state.B2BEndOfProductFirstPage[0].totalRowCount
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.EndOfProductCollectionWebPageInit();
    }
  }
}
